<template>
  <div id="app">
    <router-view/>
    <ModalsContainer />
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style lang="scss">
  @import "./styles/style.scss";
</style>
